// @ts-nocheck
import b from 'b_';
import { LessonCalendar, List } from 'education-icons';
import { Button, useGeneratePath, useStaticUrls } from 'platform-components';
import { BUTTON_SIZE } from 'platform-components/src/components/button/types';
import { useLocalStorage } from 'platform-components/src/utils/hooks/useLocalStorage';
import qs from 'query-string';
import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router';
import ym from 'react-yandex-metrika';

import { getCurrentWeek, getPeriodSearchString } from '../../course-calendar/utils';
import { COURSE_VIEW_DISPLAY_MODE } from '../typings';

import './course-view__display-mode-button.scss';

interface CourseViewDisplayModeButtonProps {
    displayMode: COURSE_VIEW_DISPLAY_MODE;
    size?: BUTTON_SIZE;
    teacherId?: number;
    teamId?: number;
}

export const CourseViewDisplayModeButton = ({
    displayMode,
    teamId,
    teacherId,
    size,
}: CourseViewDisplayModeButtonProps) => {
    const getRouterPath = useGeneratePath();
    const staticUrls = useStaticUrls();
    const history = useHistory();
    const localStorage = useLocalStorage();
    const { search } = useLocation();
    const searchParams = qs.parse(search);
    const buttonSize = size || Button.SIZE.M;

    const handleClick = useCallback(() => {
        let to;

        switch (displayMode) {
            case COURSE_VIEW_DISPLAY_MODE.CALENDAR:
                to = `${getRouterPath(staticUrls.labSubjectLessonsCalendar)}?${getPeriodSearchString(
                    getCurrentWeek(),
                    searchParams
                )}`;
                localStorage.remove('shouldShowListLessons');
                break;
            case COURSE_VIEW_DISPLAY_MODE.LIST:
                to = getRouterPath(staticUrls.labSubjectLessonsComplete);
                localStorage.set('shouldShowListLessons', true);
                break;
            default:
                throw new Error(`Не существующий тип отображения списка занятий ${displayMode}`);
        }

        ym('reachGoal', 'teacher_navigation_calendar_lessons_change_view', {
            teacherID: teacherId,
            teamID: teamId,
        });

        history.push(to);
    }, [
        displayMode,
        history,
        getRouterPath,
        staticUrls.labSubjectLessonsCalendar,
        staticUrls.labSubjectLessonsComplete,
        searchParams,
        localStorage,
        teacherId,
        teamId,
    ]);

    return (
        <div className={b('course-view', 'display-mode-button')}>
            <Button
                icon={displayMode === COURSE_VIEW_DISPLAY_MODE.LIST ? <List /> : <LessonCalendar />}
                onClick={handleClick}
                size={buttonSize}
                view={Button.VIEW.PSEUDO}
            />
        </div>
    );
};
